export interface StationDurationRadioButton {
  minutes: number;
  id: string;
}

export const StationDurations: StationDurationRadioButton[] = [
  {
    minutes: 15,
    id: '15',
  },
  {
    minutes: 30,
    id: '30',
  },
  {
    minutes: 60,
    id: '60',
  },
  {
    minutes: 90,
    id: '90',
  },
];
